import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { isValidIBAN, friendlyFormatIBAN, electronicFormatIBAN } from 'ibantools';

const normalizeIban = value => {
    if (!value) {
        return value;
    }

    return electronicFormatIBAN(value);
};

const formatIban = value => {
    if (!value) {
        return value;
    }

    return friendlyFormatIBAN(value);
};

const MAX_CHARACTERS_NUMBER = 33;

class IBANInputFieldComponent extends Component {
    isIbanValid = value =>
        value && isValidIBAN(value) ? undefined : this.props.i18nFeatureForm.IBAN_INVALID;

    validateMandatory = () => [this.isIbanValid];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                {...this.props}
                type="text"
                validate={[...this.validateMandatory(), ...validate]}
                normalize={normalizeIban}
                format={formatIban}
                maxLength={MAX_CHARACTERS_NUMBER}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
export default IBANInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/IBANInputFieldComponent.js